export const PRODUCTS_PATH = 'products';
export const MESSAGES_PATH = 'messages';
export const BRANDS_PATH = 'brands';
export const PAYMENTS_PATH = 'payment';
export const ENTERPRISE_DATA_PATH = '/enterprise';
export const DEMO_PREFIX = 'demo_';
export const PROFILES_PATH = 'profiles';
